export const reviews = [
  {
    name: "小明",
    avatar: "ri-user-3-line",
    rating: 5,
    date: "2026-08-05",
    content: "禁漫天堂真的是我用过最好的漫画平台！资源更新快、分类清晰、阅读体验流畅。尤其是离线下载功能，通勤路上看漫画太方便了。已经推荐给了身边所有喜欢看漫画的朋友。",
  },
  {
    name: "樱花飘落",
    avatar: "ri-user-heart-line",
    rating: 5,
    date: "2026-08-03",
    content: "从大学开始用禁漫天堂，到现在已经五年了。见证了平台从最初的简单界面发展到现在的海量资源和丰富功能。最喜欢的还是恋爱漫画的分类，找纯爱作品特别方便。",
  },
  {
    name: "风之少年",
    avatar: "ri-user-star-line",
    rating: 5,
    date: "2026-07-30",
    content: "作为一个热血漫画的忠实粉丝，禁漫天堂的分类体系让我能快速找到自己喜欢的战斗漫画。APP的夜间模式也做得很好，晚上躺床上看漫画也不会觉得刺眼。真心点赞！",
  },
  {
    name: "咖啡不加糖",
    avatar: "ri-user-smile-line",
    rating: 4,
    date: "2026-07-28",
    content: "平台整体体验不错，漫画种类很全，悬疑推理类的推荐算法也很准。唯一的小建议是希望能增加更多原创国产漫画的内容。总的来说瑕不掩瑜，五星推荐！",
  },
  {
    name: "夜空流星",
    avatar: "ri-user-4-line",
    rating: 5,
    date: "2026-07-25",
    content: "禁漫天堂的镜像站方案很贴心，即使主站偶尔波动也能通过镜像正常访问。更新速度也很快，热门漫画经常比其他平台早更新半天到一天。漫画迷的福音！",
  },
  {
    name: "深海鲸鱼",
    avatar: "ri-user-voice-line",
    rating: 5,
    date: "2026-07-22",
    content: "最初是朋友推荐的禁漫天堂，一用就离不开了。界面设计简洁大方，没有乱七八糟的广告干扰阅读。书签同步功能也很实用，手机和iPad无缝切换阅读进度。",
  },
  {
    name: "阳光灿烂",
    avatar: "ri-user-2-line",
    rating: 5,
    date: "2026-07-20",
    content: "禁漫天堂的内容分类做得太好了！搞笑日常类的漫画是我每天的快乐源泉。工作压力大的时候打开APP看几话搞笑漫画，整个人都轻松了。感谢平台带来的欢乐！",
  },
  {
    name: "墨染青衣",
    avatar: "ri-user-5-line",
    rating: 5,
    date: "2026-07-18",
    content: "作为奇幻冒险类漫画的深度爱好者，禁漫天堂上异世界和修仙题材的资源太丰富了。每次打开都能发现新的宝藏作品。希望平台越做越好，带来更多优质内容！",
  },
];

export const faqList = [
  {
    question: "禁漫天堂是否需要付费？",
    answer: "禁漫天堂提供大量的免费漫画内容供用户阅读。同时，平台也提供部分优质付费内容和会员服务，用户可以根据自身需求自愿选择。新用户注册即可获得一定数量的免费阅读额度。",
  },
  {
    question: "如何找到禁漫天堂的最新入口？",
    answer: "您可以通过收藏本网站页面获取最新入口信息。我们会持续更新并发布禁漫天堂所有可用的官方访问入口和镜像站地址。同时，您也可以关注我们的官方社交媒体账号获取实时更新的入口信息。",
  },
  {
    question: "禁漫天堂支持哪些设备访问？",
    answer: "禁漫天堂全面支持PC端（Windows/Mac/Linux浏览器）、移动端网页（iOS/Android浏览器）、Android APP和iOS APP。所有设备间的阅读进度和收藏数据均可通过同一账号实时同步。",
  },
  {
    question: "忘记账号密码怎么办？",
    answer: "您可以在登录页面点击「忘记密码」，通过绑定的邮箱或手机号接收验证码后重置密码。如果绑定的邮箱和手机号均已无法使用，请联系官方客服进行身份验证后找回账号。",
  },
  {
    question: "禁漫天堂的漫画更新频率如何？",
    answer: "禁漫天堂与多家漫画版权方保持合作，热门连载漫画通常能在官方更新后的24小时内同步上架。部分独家合作作品的更新速度更快。您可以通过开启更新提醒功能，第一时间获知关注漫画的更新动态。",
  },
  {
    question: "遇到无法访问的情况怎么办？",
    answer: "首先，请尝试切换不同的访问入口或镜像站点。其次，检查您的网络连接和DNS设置。如果多入口均无法访问，可能是因为您的网络环境存在限制，建议更换网络环境或使用其他设备尝试。",
  },
  {
    question: "禁漫天堂的账号可以在多设备上同时使用吗？",
    answer: "可以的。禁漫天堂支持一个账号在多台设备上同时登录使用。阅读进度、收藏夹和书签等数据会通过云端实时同步。但请注意保护好您的账号密码，不要与他人分享。",
  },
  {
    question: "如何向禁漫天堂反馈问题或建议？",
    answer: "您可以通过APP内的「帮助与反馈」功能、官方网站的「联系我们」页面、或者官方社交媒体账号向我们提交反馈。我们的客服团队会在24小时内处理您的反馈。",
  },
];